import { Component, Inject, Input } from '@angular/core';
import { Contacts, Env } from '@usimweb/core/models';
import { Router } from '@angular/router';
import { SideNavService } from '@usimweb/core/services';
import { ColorInjector } from '../ColorInjector';

@Component({
    selector: 'usimweb-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: false
})
export class NotificationComponent extends ColorInjector {
  @Input() contacts!: any[];

  public showBtn: boolean = true;

  constructor(@Inject('environment') environment: Env, private router: Router, private sidenav: SideNavService) {
    super(environment);
  }

  public view(contact: Contacts) {
    this.sidenav.toggle();
    this.router.navigate(['app/invite_confirmation/' + contact.pk]);
  }
}
